// Vendors
import { apiUtils } from '@openbank/cf-ui-architecture-core';
// Constants
import {
  GET_OTP_STATUS_PARAMS,
  REQUEST_NEW_CODE_PARAMS,
  VERIFY_OTP_PARAMS,
} from './constants/contract-otp.services.constants';
// Types
import { GenericServiceType } from '@openbank/ziniaweb-ui-core-models';
import {
  OtpStateApiType,
  RequestNewCodeServiceApiType,
  VerifyCodeServiceParams,
} from './types/contract-otp.services.types';
// Utils
import { getCheckoutIdFromUrl } from 'utils/browser-url.utils';

const getOtpStateService = async (): Promise<GenericServiceType<OtpStateApiType>> =>
  apiUtils.get({
    ...GET_OTP_STATUS_PARAMS,
    pathParams: {
      checkoutId: getCheckoutIdFromUrl(),
    },
  });

const requestNewCodeService = async (): Promise<GenericServiceType<RequestNewCodeServiceApiType>> =>
  apiUtils.post({
    ...REQUEST_NEW_CODE_PARAMS,
  });

const verifyCodeService = async ({
  otpValue,
  otpId,
}: VerifyCodeServiceParams): Promise<GenericServiceType<never>> =>
  apiUtils.post({
    ...VERIFY_OTP_PARAMS,
    params: {
      otpId,
      otpValue,
    },
  });

export { getOtpStateService, requestNewCodeService, verifyCodeService };
